import { Box, Rating, Typography } from '@mui/material'
import React, { ReactElement } from 'react'
import { UsersTechnology } from '../../../store/types'
import { Circle, RadioButtonUnchecked } from '@mui/icons-material'
import { t } from 'i18next'
import { formatTechnologyType } from '../../../store/utils'
import BasicTooltip from '../../../components/Tooltip/BasicTooltip'

type CandidateTechnologyTooltipProps = {
  children: ReactElement
  technology: UsersTechnology
}
export const CandidateTechnologyTooltip = ({ children, technology }: CandidateTechnologyTooltipProps) => {
  return (
    <BasicTooltip
      small
      followCursor
      title={
        <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1, alignItems: 'center' }}>
          <Typography>{formatTechnologyType(technology.type)}</Typography>
          <Rating
            name={`customized-color-${technology.name}`}
            defaultValue={1}
            value={technology.level / 2}
            getLabelText={(value: number) => `${value} Circle${value !== 1 ? 's' : ''}`}
            precision={0.5}
            icon={<Circle sx={{ width: 12, mr: 0.25, color: 'primary.main' }} aria-hidden={'false'} />}
            emptyIcon={
              <RadioButtonUnchecked sx={{ width: 12, mr: 0.25, color: 'primary.main' }} aria-hidden={'false'} />
            }
            aria-label={`${technology.name} ${t('components.table.header.level')}`}
          />
        </Box>
      }
    >
      {children}
    </BasicTooltip>
  )
}

export default CandidateTechnologyTooltip